import api from './index';

const postManifest = (data) => api.post('/manifest', data);

const editManifest = (data) => api.post('/updateManifest', data);

const getManifestById = (id) => api.get(`/manifest/${id}`);

const postContainer = (data) => api.post('/addContainer', data);

const deleteContainer = (data) => api.post('/deleteContainer', data);

const updateContainer = (data) => api.post('/updateContainer', data);

const getContainer = (destination) => api.get('/getContainer', {
  params: {
    ...Object.fromEntries(Object.entries({
      destination,
    }).filter((kv) => !!kv[1])),
  },
});

const warehouse = (destination) => api.get('/warehouse', {
  params: {
    ...Object.fromEntries(Object.entries({
      destination,
    }).filter((kv) => !!kv[1])),
  },
});

export {
  postManifest, editManifest, getManifestById, postContainer, deleteContainer,
  updateContainer, getContainer, warehouse,
};
